import BaseModel from '@core/model';

import IntroducerApi from '@packages/introducers/api';

export class Introducer extends BaseModel {
    static name = 'Introducer';
    static entity = 'introducers';
    static Api = IntroducerApi;

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default Introducer;
